import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import EventForm from "./EventForm";

const TimeSlots = ({
  selectedDate,
  className = "",
  events,
  fetchEventsForCustomer,
  decryptPhone,
}) => {
  console.log("events", events);
  const [clickedIndex, setClickedIndex] = useState(null);
  const [timeSlotData, setTimeSlotData] = useState({});
  const [eventModalOpen, setEventModalOpen] = useState(false);
  // const containerRef = useRef(null);

  const slots = [
    { slot: "10:30am", isFree: false },
    { slot: "11:00am", isFree: false },
    { slot: "11:30am", isFree: false },
    { slot: "12:00pm", isFree: false },
    { slot: "12:30pm", isFree: false },
    { slot: "1:00pm", isFree: false },
    { slot: "1:30pm", isFree: false },
    { slot: "2:00pm", isFree: false },
    { slot: "2:30pm", isFree: false },
    { slot: "3:00pm", isFree: false },
    { slot: "3:30pm", isFree: false },
    { slot: "4:00pm", isFree: false },
    { slot: "4:30pm", isFree: false },
    { slot: "5:00pm", isFree: false },
    { slot: "5:30pm", isFree: false },
    { slot: "6:00pm", isFree: false },
    { slot: "6:30pm", isFree: false },
    { slot: "7:00pm", isFree: false },
    { slot: "7:30pm", isFree: false },
  ];

  const updatedSlots = slots.map((ele) => {
    const slotStart = moment(
      `${moment(selectedDate).format("YYYY-MM-DD")} ${ele.slot}`,
      "YYYY-MM-DD h:mma"
    );
    const slotEnd = slotStart.clone().add(30, "minutes");
    const now = moment(); 

    const isPastSlot =
      moment(selectedDate).isSame(moment(), "day") && slotEnd.isBefore(now);

    const isFree = !events.some((eve) => {
      const eventStart = moment(eve.start); //.subtract(15, "minutes")
      const eventEnd = moment(eve.end).add(15, "minutes");

      return (
        slotStart.isBetween(eventStart, eventEnd, null, "[)") ||
        slotEnd.isBetween(eventStart, eventEnd, null, "(]")
      );
    });

    return { ...ele, isFree: isFree && !isPastSlot };
  });

  const handleClick = (index) => {
    setClickedIndex(index);
  };

  // useEffect(() => {
  //   if (containerRef.current) {
  //     containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
  //   }
  // }, [selectedDate, updatedSlots]);

  return (
    <div>
      <EventForm
        isModalOpen={eventModalOpen}
        setIsModalOpen={setEventModalOpen}
        timeSlotData={timeSlotData}
        fetchEventsForCustomer={fetchEventsForCustomer}
        setClickedIndex={setClickedIndex}
        decryptPhone={decryptPhone}
      />
      <p>{moment(selectedDate).format("dddd, MMMM D")}</p>
      {/* <div ref={containerRef} className="overflow-y-auto max-h-[400px]"> */}
      {updatedSlots.map((time, i) => (
        <div className="my-3" key={i}>
          {clickedIndex === i ? (
            <div className={`flex ${className ? className : ""}`}>
              <button className="w-1/2 btn border rounded-md text-white bg-stone-500 py-4 px-2 mr-1">
                {time.slot}
              </button>
              <button
                className="w-1/2 btn border rounded-md text-white bg-blue-500 py-4 px-2 ml-1"
                onClick={(e) => {
                  e.stopPropagation();
                  setTimeSlotData({
                    selectedDate: selectedDate,
                    timeSlot: time.slot,
                  });
                  setEventModalOpen(true);
                }}
              >
                Next
              </button>
            </div>
          ) : (
            <button
              className={`w-full btn border ${
                time.isFree
                  ? "border-blue-400 hover:border-blue-500 hover:outline hover:outline-1 text-blue-500"
                  : "border-gray-300 bg-gray-200 text-gray-400 cursor-not-allowed"
              } border-blue-400 hover:border-blue-500 hover:outline hover:outline-1 rounded-md py-4 px-8 text-blue-500 ${
                className ? className : ""
              }`}
              onClick={() => time.isFree && handleClick(i)}
              disabled={!time.isFree}
            >
              {time.slot}
            </button>
          )}
        </div>
      ))}
      {/* </div> */}
    </div>
  );
};

export default TimeSlots;
